import { WebRouletteService } from "app/public/services/web-roulette.service";
import { LocalizationService } from "app/shared/localization/localization.service";
import { FieldTypes } from "app/shared/model/enums";
import { CommonService } from "app/shared/services/common.service";
import { BehaviorSubject, Observable } from "rxjs";
import { map, switchMapTo, tap } from "rxjs/operators";

export abstract class BaseLids {

  lids$: Observable<any[]>;
  totalRecords: number;
  returnTotalRecords=false;
  loadLidsEvent$ = new BehaviorSubject(true);
  columns: { field: string; headerTranslate: string; type?: FieldTypes; width?: string; }[]
  request: { Filter: { CreatedAt: { From: Date; To: Date; }; FreeSearch: string; RouletteId: number; }; Paging: any; }
  numRowsInPage=100;
  roulettesNames: { label: string, value: number }[]
  selectedRoulette: { value: any; }
  filteredRoulettes: { label: string; value: number; }[]
  freeSearch: string
  _startDate: Date;
  _endDate: Date;
  lidId: number;
  lidDetails;
  viewLidDetails = false;
  get startDate() {
    return this._startDate;
  }
  set startDate(value) {
    if (value !== this._startDate) {
      this._startDate = value;
      this.filterCreatedDate()
    }
  }
  get endDate() {
    return this._endDate;
  }
  set endDate(value) {
    if (value !== this._endDate) {
      this._endDate = value;
      this.filterCreatedDate()
    }
  }
  constructor(private webRouletteService: WebRouletteService, private localizationService: LocalizationService, private commonService: CommonService) { }

  init(): void {
    this.commonService.changeCurrentPageHeader(this.localizationService.Translate('LIDS.TITLE'))
    this.initColumns();
    this.loadRoulettesList()
    this.createRequest();
  }
  loadRoulettesList() {
    this.webRouletteService.getRoulettesList().subscribe((res: any) => {
      if (res.Roulettes) {
        this.roulettesNames = res.Roulettes.map(roulette => { return { label: roulette.RouletteName, value: roulette.RouletteId }; });
        this.clearRoulettesFilter();
      }
    })
  }
  initLoadLidsObservable() {
    this.lids$ = this.loadLidsEvent$.pipe(
      switchMapTo(this.webRouletteService.getLids(this.request)
        .pipe(tap(res => {
          this.totalRecords = res.TotalCount;
          if(this.totalRecords)
          this.returnTotalRecords = true;
        }))
        .pipe(map(res => res.Lids))));
  }

  loadLids() {
    if (!this.lids$) {
      this.initLoadLidsObservable();
    } else {
      this.loadLidsEvent$.next(true);
    }
  }
  filterCreatedDate() {
    this.request.Filter.CreatedAt = {
      From: this._startDate ? this._startDate : null,
      To: this.endDate ? this.endDate : null
    }
    this.loadLids()
  }
  filterfreeSearch() {
    this.request.Filter.FreeSearch = this.freeSearch ? this.freeSearch : null;
    this.loadLids()
  }
  selectRoulette() {
    this.request.Filter.RouletteId = this.selectedRoulette?.value;
    this.loadLids()
  }
  clearRoulettesFilter() {
    this.filteredRoulettes = this.roulettesNames;
  }

  private initColumns() {
    this.columns = [
      {
        field: 'FirstWinCreatedDate',
        headerTranslate: 'CUSTOMERS.FIRST_WINS_CREATED_DATE',
        type: FieldTypes.fullDate
      },
      {
        field: 'FirstName',
        headerTranslate: 'CUSTOMERS.FIRST_NAME',
      },
      {
        field: 'LastName',
        headerTranslate: 'CUSTOMERS.LAST_NAME',
      },
      {
        field: 'Phone',
        headerTranslate: 'CUSTOMERS.PHONE',
      },
      {
        field: 'Email',
        width: '10%',
        headerTranslate: 'CUSTOMERS.EMAIL',
      },
      {
        field: 'Address',
        width: '20%',
        headerTranslate: 'CUSTOMERS.ADDRESS',
      },
      {
        field: 'OpenWinsCount',
        headerTranslate: 'CUSTOMERS.OPEN_WINS_COUNT',
      },
      {
        field: 'RedeemedWinsCount',
        headerTranslate: 'CUSTOMERS.REDEEMED_WINS_COUNT',
      },
      {
        field: 'ExpiredWinsCount',
        headerTranslate: 'CUSTOMERS.EXPIRED_WINS_COUNT',
      }

    ]
  }
  createRequest(pageNo?: number) {
    this.request = {
      Paging: {
        PageNo: pageNo? pageNo : 1,
        NumberRowsInPage: this.numRowsInPage
      },
      Filter: {
        RouletteId: this.selectedRoulette?.value,
        FreeSearch: this.freeSearch,
        CreatedAt: {
          From: this.startDate,
          To: this.endDate,
        },
      }
    }
    if(pageNo){
      this.initLoadLidsObservable();
    }
  }
  onOpenLidDetails(event) {
    this.lidId = event.itemId;
    this.lidDetails = event.selectedRow;
    this.viewLidDetails = true;
  }

  destroy() {
    this.commonService.clearCurrentPageHeader();
  }
}